/**
 * `Sm2MetadataSection` - collapsed `<details>` with the projection metadata.
 *
 * Surfaces `schema_version`, `source_change_position`, `source_commit_ts`,
 * `applied_at`, `account_currency`, `product_class_id`, `region`,
 * `time_zone`. These are the projection-internal facets that ops need
 * occasionally but that clutter the default render. Collapsed by default
 * per the MUR "Mockups" page.
 *
 * No PII in this section.
 */
import { FOCUS_RING_CLASS } from '../../../components/focus-ring'
import type { Account } from '../../../lib/bff-client'
import { Field, FieldValue, MonoCode, Timestamp } from './section'

export interface Sm2MetadataSectionProps {
  readonly account: Account
}

export function Sm2MetadataSection({ account }: Sm2MetadataSectionProps): JSX.Element {
  return (
    <details className="rounded-md border border-border-default bg-bg-surface px-murmuration-5 py-murmuration-3 shadow-elev-1">
      <summary
        className={`cursor-pointer text-murmuration-h3 text-text-primary ${FOCUS_RING_CLASS}`}
      >
        SM2 metadata
      </summary>
      <dl className="mt-murmuration-3 grid grid-cols-1 gap-x-murmuration-5 gap-y-murmuration-3 md:grid-cols-2">
        <Field label="Schema version">
          <FieldValue value={account.schema_version} />
        </Field>
        <Field label="Source change position">
          <MonoCode value={account.source_change_position} />
        </Field>
        <Field label="Source commit ts">
          <Timestamp value={account.source_commit_ts} />
        </Field>
        <Field label="Applied at">
          <Timestamp value={account.applied_at} />
        </Field>
        <Field label="Currency">
          <FieldValue value={account.account_currency} />
        </Field>
        <Field label="Product class id">
          <FieldValue value={account.product_class_id} />
        </Field>
        <Field label="Region">
          <FieldValue value={account.region} />
        </Field>
        <Field label="Time zone">
          <FieldValue value={account.time_zone} />
        </Field>
      </dl>
    </details>
  )
}
